// eslint-disable-next-line no-restricted-imports -- raw token read kept until this site is moved to theme.semantics
import { DS_COLOR } from '@calm/evexia-design-tokens';
// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps, Theme } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/check-with-background.svg';
import { sxAppend } from '../sx';

const styleCheckIcon = {
    // The DS_COLOR constants are used, since the string reference (e.g. 'info.main') does not render correctly in this use case.
    '& > rect': {
        fill: (theme: Theme) =>
            theme.palette.mode === 'light'
                ? DS_COLOR.LIGHT_INFO_LIGHT
                : DS_COLOR.DARK_INFO_DARK,
    },
    '& > path': {
        stroke: (theme: Theme) =>
            theme.palette.mode === 'light'
                ? DS_COLOR.LIGHT_INFO_MAIN
                : DS_COLOR.LIGHT_INFO_MAIN,
        strokeWidth: 1.75,
    },
};

export const BoldInfoCheckWithBackground = (props: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        inheritViewBox
        sx={sxAppend(styleCheckIcon, props.sx)}
        {...props}
    />
);
